import moment from "moment";
import { DataTableDefaultCellTemplates, DataTableEventArgs, Icon, ITableColumn } from "../../components";
import Logger from "../../shared/services/Logger";
import { CustomerLossHistoryConstant } from "../../shared/util/constant";
import { fetchCustomerLossHistory } from "../services/CustomerAPI";
import { CustomerLossReadDto } from "../model/CustomerLossDto";
import { IconType } from "../../components/components/Icon/interfaces";
import { useConfirmationModalContext } from "../../shared/components/ModalConfirmationContext";
import { CommonUtility } from "../../Services/CommonUtility";

class CustomerLossService {
    private dateFormat = "MM/DD/YYYY";

    public getLossHistoryTableColumns = (onRowEdit : (rowData : any, column : ITableColumn) => void, onRowDelete : (rowData : any, column : ITableColumn) => void, onLossFormCancelClick :() =>void) : ITableColumn[] => {
        const modalContext = useConfirmationModalContext();
        const tableHeaders : ITableColumn[] = [
            { 
                width : '5%',
                maxWidth : '5%',
                cellTemplate : DataTableDefaultCellTemplates.RowExpander.CellTemplate,
                // cellDataChangeHandler : DataTableDefaultCellTemplates.RowExpander.CellTemplateEventHandler,
                cellClickHandler: async (dtEventArgs: DataTableEventArgs) => {
                    const { rowData, dataTableState, eventData } = dtEventArgs;                
                    const { rowsState } = dataTableState;
                    const rowKey = rowData[dataTableState.dataTable.keyColumnName];
                    let currentRowState = rowsState[rowKey];
                
                    if (!currentRowState) {
                        currentRowState = { expanded: eventData.expand };
                    } else {
                        currentRowState = { ...currentRowState, expanded: eventData.expand };
                    }
                
                    if (!currentRowState.expanded && !dataTableState.dataTable.isFormSaved) {
                        rowsState[rowKey] = { expanded: true };
                        dataTableState.dataTable.setExpandedRowId(rowKey);
                        const result = await modalContext.showConfirmation(CustomerLossHistoryConstant.ARE_YOU_SURE_TO_EXIST);
                
                        if (!result) {                         
                            return; 
                        }
                        else
                        {
                            rowsState[rowKey] = { expanded: false };
                            dataTableState.dataTable.setExpandedRowId(rowKey);
                        }
                    }
                
                    rowsState[rowKey] = { expanded: currentRowState.expanded };
                
                    dataTableState.dataTable.setExpandedRowId(
                        currentRowState.expanded ? rowKey : null
                    );
                
                    if (currentRowState.expanded) {
                        onRowEdit(rowData, dtEventArgs.column);
                    } else {
                        onLossFormCancelClick();
                    }
                },                                                    
                cellTdClassName : 'expander-cell-td'
            },
            {
                width : '20em',
                maxWidth : '20em', 
                header : CustomerLossHistoryConstant.COMPANY_COLUMN_HEADER,
                field : "company"
            },
            {
                width : '20em',
                maxWidth : '20em', 
                header : CustomerLossHistoryConstant.DATE_OF_LOSS_COLUMN_HEADER,
                field : "dateOfLoss",
                cellDataFormatter : (dateOfLoss) => moment(dateOfLoss).format(this.dateFormat)
            },
            {
                width : '20em',
                maxWidth : '20em', 
                header : CustomerLossHistoryConstant.STATUS_COLUMN_HEADER,
                field : "claimStatusValue"
            },
            {
                width : '20em',
                maxWidth : '20em', 
                header : CustomerLossHistoryConstant.KIND_OF_LOSS_COLUMN_HEADER,
                field : "lossTypeValue"
            },,
            // {
            //     width : '5em',
            //     maxWidth : '5em', 
            //     cellTemplate : DataTableDefaultCellTemplates.EditCellTemplate.CellTemplate,
            //     cellClickHandler : (dtEventArgs : DataTableEventArgs) => onRowEdit(dtEventArgs.rowData, dtEventArgs.column)
            // },
            {
                width : '5em',
                maxWidth : '5em', 
                cellTemplate : DataTableDefaultCellTemplates.DeleteCellTemplate.CellTemplate,
                cellClickHandler : (dtEventArgs : DataTableEventArgs) => onRowDelete(dtEventArgs.rowData, dtEventArgs.column)
            }];

        return tableHeaders;
    }

    public fetchCustomerLosess = async (customerId : string) : Promise<CustomerLossReadDto[]> => {
        try {
            let lossData = await fetchCustomerLossHistory(customerId);
            lossData.forEach(item => {
                if (item.dateOfLoss) {
                    item.dateOfLoss = CommonUtility.datetimeToDateOnlyObject(item.dateOfLoss);
                }

                if (item.closedDate) {
                    item.closedDate = CommonUtility.datetimeToDateOnlyObject(item.closedDate);
                }

                if (item.reportDate) {
                    item.reportDate = CommonUtility.datetimeToDateOnlyObject(item.reportDate);
                }

                if (item.policyEffDate) {
                    item.policyEffDate = CommonUtility.datetimeToDateOnlyObject(item.policyEffDate);
                }

                if (item.policyExpDate) {
                    item.policyExpDate = CommonUtility.datetimeToDateOnlyObject(item.policyExpDate);
                }
            })
            return lossData;
        }
        catch(ex) {
            if (ex.status == 404) {
                Logger.logWarning(`No data found for customer ${customerId}`, ex);
                return [];
            }

            throw ex;
        }
    }
};

export default CustomerLossService;